import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { LocalizedPhotoCollection } from '../../models/serializable/localized-photo-collection.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LocalizedProfilePhotosComponent extends Component {
  static readonly TYPE_ID: string = '3d04a8d15ab542d19c5473a81391be89';

  constructor(
    public readonly portfolio: LocalizedPhotoCollection,
  ) {
    super();
  }

  get $typeId(): string {
    return LocalizedProfilePhotosComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LocalizedProfilePhotosComponent {
    return new LocalizedProfilePhotosComponent(
        context.fromData<LocalizedPhotoCollection>(MapUtils.getRaw(map, 'portfolio') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'portfolio': context.toData(this.portfolio),
    };
  }

  clone(): this {
    return new LocalizedProfilePhotosComponent(
        this.portfolio.clone(),
    ) as this;
  }

  isSame(other: LocalizedProfilePhotosComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.portfolio, this.portfolio);
  }
}

export class LocalizedProfilePhotosComponentBuilder extends DataModelBuilder<LocalizedProfilePhotosComponent> {
  build(context: SerializationContext, map: SerializedData): LocalizedProfilePhotosComponent {
    return LocalizedProfilePhotosComponent.fromMap(context, map);
  }
}
